import { defineQuery, useQuery } from '@pinia/colada';
import { computed, ref } from 'vue';

import * as igHashtagsAPI from '@/apis/social-listening/ig-hashtags';

export const generateIgHashtagsPostVolumeKey = (filters: Record<string, unknown>) => [
  'ig-hashtags-post-volume',
  filters,
];

interface IgHashtagsPostVolumeFilters {
  hashtags: (string | null)[];
  startDate: string | null;
  endDate: string | null;
  rule?: string;
}

export async function fetchIgHashtagsPostVolume(
  { hashtags, startDate, endDate, rule = 'and' }: IgHashtagsPostVolumeFilters,
  axiosConfig: Record<string, unknown> = {},
) {
  const response = await igHashtagsAPI.getIgHashtagsPostVolume(
    { hashtags, startDate, endDate, rule },
    axiosConfig,
  );
  return response?.data?.data;
}

export const useIgHashtagsPostVolume = defineQuery(() => {
  const hashtagName = ref<string | null>(null);
  const relatedHashtagName = ref<string | null>(null);
  const startDate = ref<string | null>(null);
  const endDate = ref<string | null>(null);

  const filters = computed(() => ({
    hashtags: [hashtagName.value, relatedHashtagName.value].filter(Boolean),
    startDate: startDate.value,
    endDate: endDate.value,
  }));

  const enabled = computed(() => !!(hashtagName.value && startDate.value && endDate.value));

  const { data, ...rest } = useQuery({
    enabled,
    key: () => generateIgHashtagsPostVolumeKey(filters.value),
    query: ({ signal }) => fetchIgHashtagsPostVolume(filters.value, { signal }),
    refetchOnMount: Boolean(enabled.value),
  });

  return {
    hashtagName,
    relatedHashtagName,
    startDate,
    endDate,
    postVolume: data,
    ...rest,
  };
});
